import type { NavType, SocialType } from '@/types/nav'

export const HEADER_NAV: NavType[] = [
  {
    title: 'Home',
    value: 'home'
  },
  {
    title: 'About',
    value: 'about'
  },
  {
    title: 'Services',
    value: 'services'
  },
  {
    title: 'Team',
    value: 'team'
  },
  {
    title: 'Contact',
    value: 'contact'
  }
]

export const SOCIAL_LIST: SocialType[] = [
  {
    icon: 'linkedin',
    link: '/'
  },
  {
    icon: 'telegram',
    link: '/'
  },
  {
    icon: 'discord',
    link: '/'
  }
]
